<template>
  <v-layout row wrap align-center >
    <v-flex xs12 class="text-xs-left pb-1">
      <div>Excellent! Enter your name, matching your driving license or government issue ID</div>
    </v-flex>

    <v-flex>
      <form autocomplete="off">
        <v-container class="grid-list-lg pa-0">
          <v-layout wrap >
            <v-flex xs6>
              <v-text-field
                @keyup="inputChange = true"
                v-validate="'required'"
                v-model="fName"
                :error-messages="errors.collect('fName')"
                label="First Name"
                data-vv-name="fName"
              ></v-text-field>
            </v-flex>

            <v-flex xs6>
              <v-text-field
                @keyup="inputChange = true"
                v-validate="'required'"
                v-model="lName"
                :error-messages="errors.collect('lName')"
                label="Last Name"
                data-vv-name="lName"
              ></v-text-field>
            </v-flex>

            <v-flex pb-0 text-xs-left>
              <span class="signup-profile-image-text">Profile image:</span>
              <upload-button title="Browse" :selectedCallback="fileSelectedFunc" />
<!--              <v-btn depressed small @click="takePicture()">-->
<!--                Camera-->
<!--              </v-btn>-->
            </v-flex>
            <span class="red--text pl-2" v-if="!profileImage">Please upload profile image.</span>
          </v-layout>
        </v-container>
      </form>
    </v-flex>

    <v-flex d-flex mt-2 xs12 class="text-lg-left">
      <v-btn
        @click="confirmName"
        :disabled="!fName || !lName || (nameVerified && !inputChange)"
        :loading="loading"
        class="mr-0 ml-0"
        color="success">Confirm my profile</v-btn>
    </v-flex>

    <v-flex d-flex xs12 v-if="!nameVerified || inputChange">
      <v-btn class="mr-0 ml-0" @click="goToSignupStep(page, 'confirm-my-phone')" color="primary">&#8592; Back</v-btn>
    </v-flex>

    <v-flex xs12 d-flex v-if="nameVerified && !inputChange">
      <v-btn class="ml-0" @click="goToSignupStep(page, 'confirm-my-phone')" color="primary">&#8592; Back</v-btn>

      <v-btn class="mr-0" @click="goToSignupStep(page, 'get-location-info')" color="primary">Next &#8594;</v-btn>
    </v-flex>

    <!------------------- USER CERTIFICATE ------------------------------------->
      <UserCertificate
        :app-icon="appIcon"
        :app-name="appName"
        :app-name-class="appNameClass()"
        :default-name="defaultName"
        :f-name="fName"
        :l-name="lName"
        :image-data="imageData" />
    <!------------------- /USER CERTIFICATE ------------------------------------->
    <!--------  DIALOG FOR IMAGE CROP ----------------->
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click.native="dialog = false">
            <span class="notranslate"><v-icon>close</v-icon></span>
          </v-btn>
          <v-toolbar-title>Profile image</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="text-xs-center align-center justify-center">
          <vue-croppie
            style="height:450px;"
            ref=croppieRef
            :viewport="{ width: 300, height: 360, type: 'square' }"
            :enableResize="false"
            :enableOrientation="true">
          </vue-croppie>

          <v-btn @click="crop()" color="success" class="mt-5">
            Update
          </v-btn>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

  </v-layout>
</template>

<script>
import crypto from '@/mixins/crypto'
import common from '@/mixins/common'
import UploadButton from '../widgets/UploadButton'
import {mapGetters, mapMutations} from 'vuex'
import VueCroppie from 'vue-croppie'
import Vue from 'vue'
// import {Camera, CameraResultType} from '@capacitor/camera'
import UserCertificate from './UserCertificate'
import 'croppie/croppie.css'

Vue.use(VueCroppie)

export default {
  name: 'ConfirmName',
  components: {UserCertificate, UploadButton},
  data () {
    return {
      apiUrl: process.env.API_URL,
      appIcon: require('@/assets/logos/' + process.env.APP_ICON),
      loading: false,
      defaultName: 'Your Name',
      appName: process.env.APP_NAME,
      errorMsg: '',
      inputChange: false,
      fName: '',
      lName: '',
      imageData: '',
      isLoader: false,
      profileImage: true,
      dialog: false,
      dictionary: {
        custom: {
          fName: {
            required: () => 'First Name is required'
          },
          lName: {
            required: () => 'Last Name is required'
          }
        }
      }
    }
  },
  props: {
    page: {
      default: 'SignUp',
      type: String
    }
  },
  computed: {
    ...mapGetters('registration', ['getUserDetails']),
    nameVerified () {
      return this.getUserDetails.name_verified
    }
  },
  mounted () {
    this.$validator.localize('en', this.dictionary)
    this.imageData = this.getUserDetails.profile_image
    this.fName = this.getUserDetails.first_name
    this.lName = this.getUserDetails.last_name
  },
  methods: {
    ...mapMutations('registration', [
      'setUser'
    ]),
    appNameClass () {
      return this.appName.length > 25 ? 'body-2' : 'subheading'
    },
    afterImageLoaded (imageData) {
      if (!imageData) {
        return new Promise((resolve) => {
          resolve('')
        })
      }
      // Split the base64 string in data and contentType
      let block = imageData.split(';')
      // Get the content type of the image
      let contentType = block[0].split(':')[1]// In this case "image/gif"
      // get the real base64 content of the file
      let realData = block[1].split(',')[1]// In this case "R0lGODlhPQBEAPeoAJosM...."

      // Convert it to a blob to upload
      let blob = this.b64toBlob(realData, contentType)
      let data = new window.FormData()
      data.append('avatar', blob)
      return this.$http({
        url: `${this.apiUrl}/ws/userservice/user/image`,
        method: 'POST',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data
      })
    },
    b64toBlob (b64Data, contentType, sliceSize) {
      contentType = contentType || ''
      sliceSize = sliceSize || 512

      let byteCharacters = atob(b64Data)
      let byteArrays = []

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize)

        let byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        let byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }

      return new Blob(byteArrays, {type: contentType})
    },
    async takePicture () {
      // const image = await Camera.getPhoto({
      //   quality: 90,
      //   allowEditing: true,
      //   resultType: CameraResultType.Uri
      // })
      // this.dialog = true
      // this.inputChange = true
      // this.$refs.croppieRef.bind({
      //   url: image.webPath
      // })
    },
    fileSelectedFunc: function (event) {
      let input = event.target
      if (input.files && input.files[0]) {
        let reader = new FileReader()
        reader.onload = (e) => {
          this.$refs.croppieRef.bind({
            url: e.target.result
          })
          this.dialog = true
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    crop () {
      let options = {
        format: 'jpeg',
        circle: false
      }
      this.$refs.croppieRef.result(options, (output) => {
        this.imageData = output
        this.dialog = false
        this.inputChange = true
        this.afterImageLoaded(output).then(data => {
          this.setUser({
            ...this.getUserDetails,
            image_id: data.data.id
          })
          this.profileImage = true
        })
      })
    },

    confirmName () {
      if (!this.imageData) {
        this.profileImage = false
        return
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.setUser({
            ...this.getUserDetails,
            first_name: this.fName,
            last_name: this.lName,
            name_verified: true,
            profile_image: this.imageData
          })
          this.inputChange = false
          this.$router.push({name: this.page, params: {step: 'get-location-info'}})
        }
      })
    }
  },
  mixins: [crypto, common]
}
</script>




// WEBPACK FOOTER //
// src/components/views/sign-up/ConfirmName.vue